/** @public */
export const DefaultSvgDefs = () => {
	return null
}
